import styled, { CSSProperties } from 'styled-components';
import {
  margin,
  MarginProps,
  padding,
  PaddingProps,
} from '../../../components/styles';
import { AppTheme } from '../../../styles/theme';

type Props = MarginProps &
  PaddingProps & {
    display?: CSSProperties['display'];
    size?: keyof AppTheme['fontSizes'];
    color?: keyof AppTheme['fontColors'];
    fontWeight?: keyof AppTheme['fontWeights'];
    lineHeight?: keyof AppTheme['lineHeights'];
    whiteSpace?: CSSProperties['whiteSpace'];
    textAlign?: CSSProperties['textAlign'];
    wordBreak?: CSSProperties['wordBreak'];
    annotation?: boolean;
  };

export const Text = styled.p<Props>`
  display: ${({ display }) => (display ? [display] : 'inline-block')};
  font-size: ${({ theme, size }) =>
    size ? theme.fontSizes[size] : theme.fontSizes.m};
  font-weight: ${({ theme, fontWeight }) =>
    fontWeight ? theme.fontWeights[fontWeight] : theme.fontWeights.normal};
  color: ${({ theme, color }) =>
    color ? theme.fontColors[color] : theme.fontColors.default};
  line-height: ${({ theme, lineHeight }) =>
    lineHeight ? theme.lineHeights[lineHeight] : theme.lineHeights.default};
  white-space: ${({ whiteSpace }) => whiteSpace};
  text-align: ${({ textAlign }) => textAlign};
  word-break: ${({ wordBreak }) => (wordBreak ? wordBreak : 'break-all')};

  ${({ annotation, theme }) =>
    annotation && {
      display: 'flex',
      fontSize: theme.fontSizes.s,
      gap: theme.spaces.s,
      color: theme.fontColors.grey,
      lineHeight: theme.lineHeights.m,
      [`&:before`]: {
        content: '"※"',
      },
    }}
  ${margin}
  ${padding}
`;
